import GiftCardExpandButton from 'components/RwdCheckout/Sections/Payment/GiftCardSection/GiftCardExpandButton/GiftCardExpandButton';

export default GiftCardExpandButton;
